<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Sales Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
         return {
            title: "Sales Report",
            items: [
               {
                  text: "Sales Report",
                  active: true,
               },                   
            ],

            sales: [],  
            states: [],
            total_sale: 0,
            stores:{
               // state_id: "",
            },
            products:{
               // store_id: "",
            },
            type: '',
            state_id: '',
            store_id: '',
            product_id: '',
            

            max_date: today_str,
            from_date: today_str,
            to_date: today_str,
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         this.fetchStates();
         // this.fetchStores();
         // this.fetchProducts();
      },

      methods: {
         fetchStates() {
            let url = "api/get-states";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.states = responseData.states;
                  console.warn(responseData.states);

               })
               .catch((err) => console.log(err));
         },

         fetchStores() {
            let url = "api/getstores_bystate?state_id=" + this.state_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.stores = responseData.stores;
                  console.warn(responseData.stores);

               })
               .catch((err) => console.log(err));
         },

         fetchProducts() {
            let url = "api/getproduct_bystore?store_id=" + this.store_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  // this.stores = responseData.stores;
                  this.products = responseData.products;
                  console.warn(responseData.products);

               })
               .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('sigofish_admin')) {
               var sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
               if(sigofish_admin.token) {
                  this.token = sigofish_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchSales(page_url = null) {

         this.getToken();
         let url = "api/sales_report?keyword=" + this.keyword + "&limit=" + this.listing_length  + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&store_id=" + this.store_id + "&product_id=" + this.product_id + "&type=" + this.type + "&state_id=" + this.state_id ;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.sales = responseData.sales.data;
               this.total_sale = responseData.total;
               
               this.pagination = responseData.sales.links;
               this.from = responseData.sales.from;
               this.to = responseData.sales.to;
               this.total = responseData.sales.total;
            
         })
         .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
         if(error.response.status == 422) {               
            if (error.response.data) {
               this.errors = error.response.data.message;
            } 
            this.$swal("", error.response.statusText, "error");
            
         } else if(error.response.status == 500) {
            this.$swal("", error.response.statusText, "error");
         } 
         else if(error.response.status == 401) {
            this.$swal("", error.response.statusText, "error");
            this.$router.push({ name: "login" });
         } else {
            this.$swal("", "Something went wrong", "error");
         }
         } else {
         this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         }, 
         download() {

         let url = "api/sales_report_download?&from_date=" + this.from_date+ "&to_date=" + this.to_date + "&store_id=" + this.store_id + "&product_id=" + this.product_id + "&type=" + this.type + "&state_id=" + this.state_id;

         const config = {
            headers: {
               "Content-type": "application/json",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            responseType: "arraybuffer",
         };
         // var data = JSON.stringify({
         //    "fuel_station": this.fuel_station_id,
         //    "from_date": this.from_date,
         //    "to_date": this.to_date,

         // });
         this.getToken();

         this.$axios
         .get(url, config)
         .then((response) => {
            //console.log(response);
            let blob = new Blob([response.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
         
            let filename = "sales" + "-" + this.from_date + "-" + this.to_date + ".pdf";


            link.download = filename;
            link.click();
                  
         })
         .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
         if(error.response.status == 422) {               
            if (error.response.data) {
               this.errors = error.response.data.message;
            } 
            this.$swal("", error.response.statusText, "error");
            
         } else if(error.response.status == 500) {
            this.$swal("", error.response.statusText, "error");
         } 
         else if(error.response.status == 401) {
            this.$swal("", error.response.statusText, "error");
            this.$router.push({ name: "login" });
         } else {
            this.$swal("", "Something went wrong", "error");
         }
         } else {
         this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         },


         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="from_date" :max="max_date" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>   
                     </div>

                     <div class="form-group col-lg-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="to_date" :min="from_date" :max="max_date" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>

                     <div class="form-group col-lg-4">
                        <label>State</label>
                        <b-input-group-prepend>
                              <select class="form-control" v-model="state_id"  @change="fetchStores()">
                                 <option value="">Select</option>
                                 <option :value="state.id" v-for="state in states" :key="state.id">{{state.states}}</option>
                              </select>
                        </b-input-group-prepend>
                     </div>
                     
                     <b-form-group class="form-group col-lg-4" v-if="state_id">
                        <label>Store <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="store_id"  @change="fetchProducts()">
                              <option value="">All</option>
                              <option :value="store.id" v-for="store in stores" :key="store.id">{{store.name}}</option>
                           </select>
                     </b-form-group>

                     <div class="form-group col-lg-4">
                        <label>Type</label>
                        <select class="form-control" v-model="type">
                           <option value="">All</option>
                           <option value="1">Online</option>
                           <option value="2">Store</option>
                          
                        </select>
                     </div>

                     <b-form-group class="form-group col-lg-4" v-if="store_id">
                        <label>Products <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="product_id">
                              <option value="">All</option>
                              <option :value="product.id" v-for="product in products" :key="product.id">{{product.name}}</option>
                           </select>
                     </b-form-group>

                  </div>
                  <!----- filters area ends---->
                  


                 
                  <div class="row">
                     <div class="col-9">
                        <button class="btn btn-primary me-2" type="button" @click="fetchSales()">View</button>
                        <button class="btn btn-primary me-2" type="button" v-if="sales.length"   @click="download()">Download</button>
                     </div>
                    
                  </div>
               </div>
            </div>
            <div class="row mb-3">
               <div class="col-lg-3">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h5 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-1 py-1 mb-1"> Total Amount <br><br>Rs. {{total_sale}}
                                             </h5>
                        </b-card>     
            </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchSales()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"  @keyup="fetchSales()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Sl No</th>   
                              <th>Product</th>
                              <th>Total Weight(Kg)</th>
                              <th>Total Amount</th>
                              <th>Store</th>
                              <th>Order ID</th>
                              <th>Type</th>
                              <th>Created On</th>
                             
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(sales.length)">
                           <tr v-for="(sale,index) in sales" :key="sale.id">
                              <td>{{index + from}}</td>
                              <td>
                                 {{sale.product_name_display}}<br>
                                 {{sale.cutting_type_display}}
                              </td> 
                              <td>{{sale.total_weight}}</td> 
                              <td>Rs.{{sale.total_price}}</td> 
                              <td>{{sale.name}}</td>
                              <td>#{{sale.order_id}}</td> 
                              <td>
                                 <span v-if="sale.customer_type == 1" class="badge rounded-pill bg-success">Online</span>
                                 <span v-if="sale.customer_type == 2" class="badge rounded-pill bg-danger">Store</span>
                              </td>
                              <td>
                                 {{sale.converted_created_at}}
                              </td>
                              
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No Sales found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(sales.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchSales(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&product_id=' + product_id + '&type=' + type + '&state_id=' + state_id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
